import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zanting",
  "use": "icon-zanting-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zanting\"><defs><style type=\"text/css\"></style></defs><path d=\"M192 64h640a128 128 0 0 1 128 128v640a128 128 0 0 1-128 128H192a128 128 0 0 1-128-128V192a128 128 0 0 1 128-128z m0 76.8a51.2 51.2 0 0 0-51.2 51.2v640a51.2 51.2 0 0 0 51.2 51.2h640a51.2 51.2 0 0 0 51.2-51.2V192a51.2 51.2 0 0 0-51.2-51.2H192zM358.4 256a38.4 38.4 0 0 1 38.4 38.4v435.2a38.4 38.4 0 0 1-76.8 0V294.4a38.4 38.4 0 0 1 38.4-38.4z m307.2 0a38.4 38.4 0 0 1 38.4 38.4v435.2a38.4 38.4 0 1 1-76.8 0V294.4a38.4 38.4 0 0 1 38.4-38.4z\" p-id=\"3878\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zanting.svg
// module id = 1068
// module chunks = 38